<template>
  <div class="file-pdf">
    <iframe :src="src" frameborder="0"></iframe>
  </div>
</template>

<script>
export default{
  props: {
    src: { default: '' }
  }
}
</script>

<style lang="less" scoped>
  .file-pdf{
    width: 100%;
    height: 100%;
    iframe{
      width: 100%;
      height: 100%;
    }
  }
</style>
